<template>
  <div class="svn-list">
    <Row style="background-color: #fff; border-radius: 4px">
      <Col :md="nodeListSpan" v-show="nodeListShow">
        <Card>
          <nodeList ref="nodeList" v-on:nodeChange="init" nodeType="svn"></nodeList>
        </Card>
      </Col>
      <Col :md="contentSpan" style="border-left: 6px solid #f5f7f9;">
        <ProjectMember ref="ProjectMember" :projectId="projectId" :node="node"></ProjectMember>
        <Card shadow>
          <Row class="sm-pc-w100">
            <Col :md="22">
            <span>
                <Button @click="nodeListShowBtn(false)" v-show="nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}" class="mob-hidden">
                  <Icon type="ios-arrow-back" />
                </Button>
                <Button @click="nodeListShowBtn(true)" v-show="!nodeListShow" type="primary" size="small" :style="{float: 'left', marginRight: '10px'}">
                  <Icon type="ios-arrow-forward" />
                </Button>
              </span>
              <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="60" @submit.native.prevent>
                <FormItem label="项目名称">
                  <Input v-model="tableSearchForm.name" style="width: 200px" />
                </FormItem>
                <FormItem :label-width="0" class="mob-align-right">
                  <Button type="primary" @click="getTableData()">搜索</Button>
                  <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
                </FormItem>
              </Form>
            </Col>
            <!-- <Col span="24" :md="2" class="align-right">
              <Button
                style="float: right;"
                @click="edit()"
                type="primary"
                :style="{marginBottom: '10px'}"
                v-if="$store.state.user.superuser"
                icon="md-add">添加Gitlab群组</Button>
            </Col> -->
          </Row>
          <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
          <Table
            v-else
            stripe
            border
            highlight-row
            :loading="tableLoading"
            ref="table"
            :data="table.data"
            :columns="table.columns"></Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: left;">
              当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
            </div>
            <div style="float: right;">
              <page
                :total="table.count"
                :current="table.page"
                :page-size="table.size"
                @on-change="getTableData"></page>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getProjects } from '@/api/tools/svn'
import ProjectMember from './ProjectMember'
import nodeList from '../node-list'
// import moment from 'moment'

export default {
  components: {
    nodeList,
    ProjectMember
  },
  data () {
    return {
      selectNodes: [],
      nodeListSpan: 4,
      contentSpan: 20,
      nodesList: [],
      nodeListShow: true,
      node: null,
      projectId: null,
      tableLoading: false,
      tableSearchForm: {
        name: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'name',
            align: 'center'
          },
          {
            title: 'URL',
            key: 'url',
            align: 'center'
          },
          {
            title: '操作',
            align: 'center',
            width: 200,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.projectId = params.row.name
                      this.node = params.row.node
                      this.$refs.ProjectMember.openModal()
                    }
                  }
                }, '配置项目成员')
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      listError: false
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    init (value) {
      this.selectNodes = value
      this.getTableData()
    },
    nodeListShowBtn (status) {
      this.nodeListShow = status
      if (status) {
        if (this.screenWidth < 1025) {
          this.nodeListSpan = 8
          this.contentSpan = 16
        } else {
          this.nodeListSpan = 4
          this.contentSpan = 20
        }
      } else {
        this.nodeListSpan = 0
        this.contentSpan = 24
      }
    },
    onResultChange (val) {
    },
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      this.tableSearchForm['nodes'] = this.selectNodes.join(',')
      getProjects(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: ''
      }
    },
    // 编辑完成
    editComplete (isUpdate) {
      // if (isUpdate) {
      //   this.getTableData()
      // } else {
      //   this.getTableData(this.table.page)
      // }
    }
  }
}
</script>

<style scoped>

</style>
